import { observer } from 'mobx-react';
import React from 'react';
import TableToolbar from '../../shared/tableToolbar';
import AMATimeUnitSettingStore from './Store';
import * as api from '../../../stores/api';

@observer
class AMATimeUnitSettingToolbar extends React.Component {
  handleSearchChange = (_, { value }) => {
    AMATimeUnitSettingStore.setFieldsValue({ keyword: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    AMATimeUnitSettingStore.refetch({}, true);
  };

  handleReset = () => {
    AMATimeUnitSettingStore.resetStore();
  };

  handleCreate = () => {
    return AMATimeUnitSettingStore.toggleModal(true, { modalType: 'create' })();
  };

  render() {
    const { keyword, loading } = AMATimeUnitSettingStore;
    return (
      <TableToolbar.Container>
        <TableToolbar.Left onSubmit={this.handleSubmit}>
          <TableToolbar.Input
            placeholder="Search"
            value={keyword}
            onChange={this.handleSearchChange}
            disabled={loading}
          />
          <TableToolbar.SubmitButton disabled={loading}>Search</TableToolbar.SubmitButton>
          <TableToolbar.HighLightButton
            className="negative"
            disabled={loading}
            onClick={this.handleReset}
            style={{ marginLeft: '5px' }}
          >
            Clear
          </TableToolbar.HighLightButton>
        </TableToolbar.Left>
        <TableToolbar.Right>
          {api.isAdminOrMagStaffOrAccounting() && (
            <TableToolbar.HighLightButton className="positive" disabled={loading} onClick={this.handleCreate}>
              Add Rule
            </TableToolbar.HighLightButton>
          )}
        </TableToolbar.Right>
      </TableToolbar.Container>
    );
  }
}

export default AMATimeUnitSettingToolbar;
